import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Check if fbq already exists to avoid duplicate initialization
    if ((window as any).fbq) return;
    // Meta Pixel Code
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize fbq function
    const fbq = function () {
      if ((fbq as any).callMethod) {
        ;
        (fbq as any).callMethod.apply(fbq, arguments);
      } else {
        ;
        (fbq as any).queue.push(arguments);
      }
    };
    (window as any).fbq = fbq;
    (window as any)._fbq = fbq;
    (fbq as any).push = fbq;
    (fbq as any).loaded = true;
    (fbq as any).version = '2.0';
    (fbq as any).queue = [];
    // Initialize pixel and track PageView once script loads
    script.onload = () => {
      ;
      (window as any).fbq('init', '905280231851143');
      (window as any).fbq('track', 'PageView');
    };
  }, []);
  return <noscript data-id="element-81">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=905280231851143&ev=PageView&noscript=1" alt="" data-id="element-82" />
    </noscript>;
}